<template>
  <transition name="el-fade-in-linear">
    <div
      ref="myDiv"
      :class="['wind-farm-modal-wrapper', className]"
      :style="{
        width
      }"
      v-adrag
    >
      <div class="title">
        <div v-if="leftArrow" class="icon-wrapper" @click="handleLeftClick">
          <i class="el-icon-arrow-left"></i>
        </div>
        <span>
          {{ title }}
        </span>
        <div class="close-btn" @click="handleClose">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </div>
      </div>
      <div
        class="content"
        :style="{
          height: height
        }"
      >
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '-'
    },
    invisbility: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '400px'
    },
    width: {
      type: String,
      default: '420px'
    },
    className: {
      type: String,
      default: ''
    },
    leftArrow: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    adrag: {
      bind(el) {
        const dragDom = el.querySelector('.title');

        dragDom.onmousedown = e => {
          const startX = e.clientX;
          const startY = e.clientY;

          const originX = el.offsetLeft;
          const originY = el.offsetTop;

          document.onmousemove = function(e) {
            // 通过事件委托，计算移动的距离
            const l = e.clientX - startX;
            const t = (e.clientY < 85 ? 85 : e.clientY) - startY;

            // 移动当前元素
            el.style.left = `${l + originX}px`;
            el.style.top = `${t + originY}px`;
          };

          document.onmouseup = function() {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      }
    }
  },
  methods: {
    handleLeftClick() {
      this.$emit('leftClick');
    },
    handleClose() {
      this.$emit('closeClick');
    }
  }
};
</script>

<style lang="less">
.wind-farm-modal-wrapper {
  &.not-login {
    left: 0.3%;
  }
  position: absolute;
  background: #c8e0f5;
  width: 420px;
  z-index: 500;
  left: 225px;
  top: 4px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transform: translate(0, 0);
  .title {
    cursor: move;
    .icon-wrapper {
      margin-right: 3px;
      i {
        cursor: pointer;
      }
    }
    height: 40px;
    font-size: 20px;
    padding: 0 10px;
    display: flex;
    color: #0057aa;
    border-radius: 8px 8px 0px 0px;
    font-weight: bold;
    align-items: center;
    overflow: hidden;

    background: linear-gradient(
      to bottom,
      #76b4de 0%,
      #9fcaea 20%,
      #c8e0f5 50%,
      #c8e0f5 100%
    );
  }
  .close-btn {
    border-radius: 50%;
    border: 2px solid #0057aa;
    cursor: pointer;
    position: absolute;
    right: 10px;
  }
  .content {
    overflow: auto;
    // padding: 5px 10px;
  }
  & > div {
    &::-webkit-scrollbar {
      width: 5px; /*滚动条宽度*/
      height: 0px; /*滚动条高度*/
      background-color: #ffffff;
    }
    //滚动条的滑块
    &::-webkit-scrollbar-thumb {
      background-color: #b4d3ee;
      border-radius: 3px;
    }
  }
}
</style>
